export class medicalQuestionnarieFormList {
    constructor(ApiRes = {}, FormPk = '', FormNm = '', FormAttr = []) {
        this.ApiRes = ApiRes;
        this.FormPk = FormPk;
        this.FormNm = FormNm;
        this.FormAttr = FormAttr;
    }
}
